export enum BonusClassification {
    Contract = 'CONTRACT',
    Bonus = 'BONUS',
    BonusPlus = 'BONUS_PLUS',
}

const translationObject: { [Key in BonusClassification]: string } = {
    [BonusClassification.Bonus]: 'app.bonusClassification.bonus',
    [BonusClassification.BonusPlus]: 'app.bonusClassification.bonusPlus',
    [BonusClassification.Contract]: 'app.bonusClassification.contract',
};

export const getBonusClassificationTranslationId = (status: BonusClassification): string => {
    return translationObject[status] || '';
};
